module.exports = __webpack_public_path__ + "img/skiing005.dce06307.jpg";